import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import { safeDayjs } from "@/helpers/dateHelper"
import { DirectDebit } from "./directDebit"
import {
  DirectDebitDefaultStatus,
  DirectDebitStatus,
  IDirectDebit,
} from "./directDebit.types"
import { DirectDebitMandate } from "@/api/backofficeRest/generated/model"

export type IDirectDebitRaw = DirectDebitMandate

const capitalise = (word: string) =>
  word.charAt(0).toUpperCase() + word.slice(1)

const toPascalCase = (value: string) =>
  value.split("_").map(capitalise).join("")

export const DirectDebitParser: IParser<IDirectDebit, IDirectDebitRaw> = {
  toDomain: (data: IDirectDebitRaw) => {
    try {
      return new DirectDebit(
        data.id,
        toPascalCase(data.status) as DirectDebitStatus,
        data.paymentMethodType,
        toPascalCase(data.defaultStatus) as DirectDebitDefaultStatus,
        dayjs(data.createdAt),
        safeDayjs(data.fromDttm),
        undefined,
        data.bankAccount ?? undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
